const KEY = "paroloteca_student";

export const MODE_LABELS = { definizioni: "Quiz definizioni", fumetti: "Quiz fumetti", mappe: "Gioco mappe" };

export const getStudent = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

export const setStudent = (s) => (s ? localStorage.setItem(KEY, JSON.stringify(s)) : localStorage.removeItem(KEY));
